import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * "Related Services" section: crawlable <a href> links to approved internal pages.
 * links: [{label, url}] (already filtered to live, approved pages by the server).
 */
export default function RelatedServices({ links, heading = "Related Services", testId = "related-services" }) {
  const items = (links || []).filter((l) => l && l.url && l.url.startsWith("/") && !l.url.startsWith("//"));
  if (items.length === 0) return null;
  return (
    <section className="py-12 border-t border-slate-100 bg-white" data-testid={testId} aria-labelledby={`${testId}-heading`}>
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <h2 id={`${testId}-heading`} className="font-display font-bold text-2xl text-[#0F172A]">
          {heading}
        </h2>
        <ul className="mt-5 flex flex-wrap gap-3">
          {items.map((l) => (
            <li key={l.url}>
              <Link
                to={l.url}
                data-testid={`${testId}-link-${l.url.replace(/^\//, "")}`}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-[#1E3A8A]/25 bg-[#F8FAFC] text-sm font-semibold text-[#1E3A8A] hover:bg-[#1E3A8A]/5 hover:border-[#1E3A8A]/50 transition-colors"
              >
                {l.label}
                <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
